export default __webpack_public_path__ + "static/hairpedia-border-6554e949441a41d148c366cc69df4462.png";